import { useE, useRerender, useS } from "./hooks"
import { message } from "./message"
import { store } from "./store"
import { is_mobile, S } from "./util"
import { createResourceScope, ResourceScope } from './resources'

const { named_log, Q, keys, entries, from, values, node, set, on, unpick, rand, defer, strings } = window as any
const log = named_log('track_player')

export const track_lists = {
    NONE: 'misc',
    THEME: 'theme',
    CHOSIC_FREE: 'Chosic free',
    APORIA: 'iwamizu Aporia',
}
export const track_ids = {
    STARDUST: 'stardust',
    YOU_KNOW_WHY: 'you_know_why',
    JOY_TO_THE_WORLD: 'joy_to_the_world',
    LOVE_THEY: 'love_they',

    FUR_ELISE: 'fur_elise',
    THE_GIRL_FROM_FRANCE: 'the_girl_from_france',
    BABY_I_MADE_A_MISTAKE: 'baby_i_made_a_mistake',
    LAME_WALTZ: 'lame_waltz',
    SHOUZEN: 'shouzen',
    LA_CAMPANELLA: 'la_campanella',
    UTOPIA: 'utopia',
    FLOCCINAUCINIHILIPILIFICATION: 'floccinaucinihilipilification',
    WATCH_MY_SOUL_SPEAK: 'watch_my_soul_speak',
    WROTE_YOU_A_LETTER_BUT_BURNED_IT_MYSELF_SO_I_WROTE_A_SONG_ABOUT_YOU_INSTEAD_AND_MOVED_IT_TO_TRASH: 'wrote_you_a_letter_but_burned_it_myself_so_i_wrote_a_song_about_you_instead_and_moved_it_to_trash',

    IM_GOD: 'im_god',
    RALLY_HOUSE: 'rally_house',
    // VON_DUTCH: 'von_dutch',
    KANGAROO_COURT: 'kangaroo_court',
    RUSH: 'rush',
    HEARTBEAT: 'heartbeat',
    n3005: '3005',
    HELLO_SEATTLE: 'hello_seattle',
    ITS_NICE_TO_BE_ALIVE: 'its_nice_to_be_alive',
    RADIO: 'radio',
    THE_LESS_I_KNOW_THE_BETTER: 'the_less_i_know_the_better',
    FRENESI: 'frenesi',

    ALL_THE_THINGS_SHE_SAID: 'all_the_things_she_said',
    ANGELS: 'angels',
    BEAUTIFUL: 'beautiful',
    CLOVERS: 'clovers',
    DEEP_SEA: 'deep_sea',
    DOSES_AND_MIMOSAS: 'doses_and_mimosas',
    EVERYTHING_IS_EMBARRASSING: 'everything_is_embarrassing',

    MY_FAVORITE_FISH: 'my_favorite_fish',
    FIELDS_OF_GOLD: 'fields_of_gold',
    // GIVE_IT_TO_ME_STRAIGHT: 'give_it_to_me_straight',
    HAUNTED: 'haunted',
    I_DONT_KNOW_YOU: 'i_dont_know_you',
    I_SAY_FEVER: 'i_say_fever',
    IF_YOURE_NOT_THE_ONE: 'if_youre_not_the_one',
    ILLUSION: 'illusion',
    IS_THIS_HOW_YOU_FEEL: 'is_this_how_you_feel',
    LEAVE_ME_LIKE_THIS: 'leave_me_like_this',
    NEW_RULES: 'new_rules',
    OSAKA_LOOP_LINE: 'osaka_loop_line',
    PUSH: 'push',
    RED: 'red',
    SANTA_FE: 'santa_fe',
    SEXY_TO_SOMEONE: 'sexy_to_someone',
    SOMEBODY_THAT_I_USED_TO_KNOW: 'somebody_that_i_used_to_know',
    SPIT_IN_MY_FACE: 'spit_in_my_face',
    I_WISH_I_WAS_STEPHEN_MALKMUS: 'i_wish_i_was_stephen_malkmus',
    THE_PERFECT_GIRL: 'the_perfect_girl',
    VAMPIRE_EMPIRE: 'vampire_empire',
    WHEN_AM_I_GONNA_LOSE_YOU: 'when_am_i_gonna_lose_you',
    WHEN_I_GET_HOME: 'when_i_get_home',
    // STARRY_NIGHT: 'starry_night',
    YOURE_THE_ONE: 'youre_the_one',
    NULL: 'null',
    SUPERSONIC: 'supersonic',

    FANTASY: 'fantasy',

    // 2026-03-05
    ASSIS: 'assis',
    BACK_OF_MY_MIND: 'back_of_my_mind',
    BBYDOLL: 'bbydoll',
    ESCALATOR: 'escalator',
    LLTB: 'lltb',
    NEWJEANS: 'newjeans',
    REFLEKTOR: 'reflektor',
    RUN_AWAY_MY_LOVER: 'run_away_my_lover',
    // SYNESTHESIA: 'synesthesia',
    BABY_MY_PHONE: 'baby_my_phone',
    TESSELLATE: 'tessellate',
    TIGHT_DRESS: 'tight_dress',
    UNWRITTEN: 'unwritten',
    DISCO: 'disco',
    ACETONE: 'acetone',
    FALL_IN_LOVE: 'fall_in_love',
    PARKING_LOT: 'parking_lot',
    INTERMISSION: 'intermission',
    DONT_TAKE_THE_MONEY: 'dont_take_the_money',
    HEAVEN_HELL: 'heaven_hell',
    FIFTEEN_STEP: 'fifteen_step',
    TRAVELING_AT_THE_SPEED_OF_LIGHT: 'traveling_at_the_speed_of_light',
    SLIP_AWAY: 'slip_away',
    GO: 'go',
    CALIFORNIA_DREAMIN: 'california_dreamin',
    CIAO: 'ciao',
    IPHONE: 'iphone',
    LET_U_GO: 'let_u_go',
    MAKE_YOU_MINE: 'make_you_mine',
    MONTAGEM_MYSTERIOUS_GAME: 'montagem_mysterious_game',
    VON_DUTCH: 'von_dutch',
    ADVENTURE_OF_A_LIFETIME: 'adventure_of_a_lifetime',
    EASY: 'easy',
    EMPIRE_ANTS: 'empire_ants',
    FILLE: 'fille',
    FIRE_FLIES: 'fire_flies',
    GIVE_IT_TO_ME_STRAIGHT: 'give_it_to_me_straight',
    ILLIT: 'illit',
    WANA: 'wana',
    GNARLY: 'gnarly',
    INFINITE_CITIES: 'infinite_cities',
    I_LOVE_IT: 'i_love_it',
}

export type track = {
    title: string,
    artist: string,
    album: string,
    list: string,
    audio: string,
    image: string,
    href: string,
    flavor?: string,
}
export const tracks: { [id:string]: {
    title: string,
    artist: string,
    album: string,
    list: string,
    audio: string,
    image: string,
    href: string,
    id?: string,
    flavor?: string,
} } = {
    [track_ids.STARDUST]: {
        title: 'Stardust',
        artist: 'JSH',
        album: undefined,
        list: track_lists.CHOSIC_FREE,
        audio: '/raw/audio/tracks/chosic-free/stardust.mp3',
        image: 'https://www.chosic.com/wp-content/uploads/FreeMusicTagsImages/120/Beats.jpg',
        href: 'https://www.chosic.com/download-audio/27019/',
    },
    [track_ids.YOU_KNOW_WHY]: {
        title: 'You Know Why',
        artist: 'Loyalty Freak Music',
        album: undefined,
        list: track_lists.CHOSIC_FREE,
        audio: '/raw/audio/tracks/chosic-free/you_know_why.mp3',
        image: 'https://www.chosic.com/wp-content/uploads/FreeMusicTagsImages/120/Beats.jpg',
        href: 'https://www.chosic.com/download-audio/24220/',
    },
    [track_ids.JOY_TO_THE_WORLD]: {
        title: 'Joy to the World Master',
        artist: 'John Bartmann',
        album: undefined,
        list: track_lists.CHOSIC_FREE,
        audio: '/raw/audio/tracks/chosic-free/joy_to_the_world_master.mp3',
        image: 'https://www.chosic.com/wp-content/uploads/FreeMusicTagsImages/120/Ambient.jpg',
        href: 'https://www.chosic.com/download-audio/28351/',
    },
    [track_ids.LOVE_THEY]: {
        title: 'Love They',
        artist: 'Loyalty Freak Music',
        album: undefined,
        list: track_lists.CHOSIC_FREE,
        audio: '/raw/audio/tracks/chosic-free/love_they.mp3',
        image: 'https://www.chosic.com/wp-content/uploads/FreeMusicTagsImages/120/Relaxing.jpg',
        href: 'https://www.chosic.com/download-audio/25151/',
    },

    [track_ids.FUR_ELISE]: {
        title: 'Für Elise',
        artist: 'iwamizu',
        album: 'Aporia',
        list: track_lists.APORIA,
        audio: '/raw/audio/tracks/aporia/01-fur_elise.mp3',
        image: '/raw/audio/tracks/aporia/cover.jpg',
        href: 'https://iwamizu.bandcamp.com/album/aporia',
    },
    [track_ids.THE_GIRL_FROM_FRANCE]: {
        title: 'The Girl from France',
        artist: 'iwamizu',
        album: 'Aporia',
        list: track_lists.APORIA,
        audio: '/raw/audio/tracks/aporia/02-the_girl_from_france.mp3',
        image: '/raw/audio/tracks/aporia/cover.jpg',
        href: 'https://iwamizu.bandcamp.com/album/aporia',
    },
    [track_ids.BABY_I_MADE_A_MISTAKE]: {
        title: 'Baby I Made a Mistake',
        artist: 'iwamizu',
        album: 'Aporia',
        list: track_lists.APORIA,
        audio: '/raw/audio/tracks/aporia/03-baby_i_made_a_mistake.mp3',
        image: '/raw/audio/tracks/aporia/cover.jpg',
        href: 'https://iwamizu.bandcamp.com/album/aporia',
    },
    [track_ids.LAME_WALTZ]: {
        title: 'Lame Waltz',
        artist: 'iwamizu',
        album: 'Aporia',
        list: track_lists.APORIA,
        audio: '/raw/audio/tracks/aporia/04-lame_waltz.mp3',
        image: '/raw/audio/tracks/aporia/cover.jpg',
        href: 'https://iwamizu.bandcamp.com/album/aporia',
    },
    [track_ids.SHOUZEN]: {
        title: '悄然 / Shouzen',
        artist: 'iwamizu',
        album: 'Aporia',
        list: track_lists.APORIA,
        audio: '/raw/audio/tracks/aporia/05-shouzen.mp3',
        image: '/raw/audio/tracks/aporia/cover.jpg',
        href: 'https://iwamizu.bandcamp.com/album/aporia',
    },
    [track_ids.LA_CAMPANELLA]: {
        title: 'La Campanella',
        artist: 'iwamizu',
        album: 'Aporia',
        list: track_lists.APORIA,
        audio: '/raw/audio/tracks/aporia/06-la_campanella.mp3',
        image: '/raw/audio/tracks/aporia/cover.jpg',
        href: 'https://iwamizu.bandcamp.com/album/aporia',
    },
    [track_ids.UTOPIA]: {
        title: 'Utopia',
        artist: 'iwamizu',
        album: 'Aporia',
        list: track_lists.APORIA,
        audio: '/raw/audio/tracks/aporia/07-utopia.mp3',
        image: '/raw/audio/tracks/aporia/cover.jpg',
        href: 'https://iwamizu.bandcamp.com/album/aporia',
    },
    [track_ids.FLOCCINAUCINIHILIPILIFICATION]: {
        title: 'Floccinaucinihilipilification',
        artist: 'iwamizu',
        album: 'Aporia',
        list: track_lists.APORIA,
        audio: '/raw/audio/tracks/aporia/08-floccinaucinihilipilification.mp3',
        image: '/raw/audio/tracks/aporia/cover.jpg',
        href: 'https://iwamizu.bandcamp.com/album/aporia',
    },
    [track_ids.WATCH_MY_SOUL_SPEAK]: {
        title: 'Watch My Soul Speak',
        artist: 'iwamizu',
        album: 'Aporia',
        list: track_lists.APORIA,
        audio: '/raw/audio/tracks/aporia/09-watch_my_soul_speak.mp3',
        image: '/raw/audio/tracks/aporia/cover.jpg',
        href: 'https://iwamizu.bandcamp.com/album/aporia',
    },
    [track_ids.WROTE_YOU_A_LETTER_BUT_BURNED_IT_MYSELF_SO_I_WROTE_A_SONG_ABOUT_YOU_INSTEAD_AND_MOVED_IT_TO_TRASH]: {
        title: 'Wrote You a Letter But Burned It Myself So I Wrote a Song About You Instead and Moved It to Trash',
        artist: 'iwamizu',
        album: 'Aporia',
        list: track_lists.APORIA,
        audio: '/raw/audio/tracks/aporia/10-wrote_you_a_letter_but_burned_it_myself_so_i_wrote_a_song_about_you_instead_and_moved_it_to_trash.mp3',
        image: '/raw/audio/tracks/aporia/cover.jpg',
        href: 'https://iwamizu.bandcamp.com/album/aporia',
    },


    [track_ids.IM_GOD]: {
        title: 'I\'m God',
        artist: 'Clams Casino',
        album: 'Instrumental Relics',
        list: track_lists.THEME,
        audio: '/raw/audio/tracks/theme/im_god.mp3',
        image: '/raw/audio/tracks/theme/im_god.jpg',
        href: 'https://clamscasinoofficial.bandcamp.com/track/im-god-with-imogen-heap',
        flavor: 'blasphemous!',
    },
    [track_ids.RALLY_HOUSE]: {
        title: 'Rally House',
        artist: 'prod. DTM',
        album: 'Rally House',
        list: track_lists.THEME,
        audio: '/raw/audio/tracks/theme/rally_house_by_pedalalex.mp3',
        image: '/raw/audio/tracks/theme/rally_house.webp',
        href: 'https://soundcloud.com/prod-dtm/rally-house?in=pedalalex/sets/rally-house',
        flavor: 'rally car house music?',
    },
    // [track_ids.VON_DUTCH]: {
    //     title: 'Von Dutch (Official Video)',
    //     artist: 'Charlie XCX',
    //     album: 'Von Dutch',
    //     list: track_lists.THEME,
    //     audio: '/raw/audio/tracks/theme/von_dutch_by_charlie_xcx.mp3',
    //     image: '/raw/audio/tracks/theme/von_dutch.jpg',
    //     href: 'https://www.youtube.com/watch?v=cwZ1L_0QLjw',
    // },
    [track_ids.KANGAROO_COURT]: {
        title: 'Kangaroo Court',
        artist: 'Capital Cities',
        album: 'In A Tidal Wave of Mystery',
        list: track_lists.THEME,
        audio: '/raw/audio/tracks/theme/kangaroo_court_by_capital_cities.mp3',
        image: '/raw/audio/tracks/theme/tidal_wave_capital_cities.jpg',
        href: 'https://www.youtube.com/watch?v=CJinWua98NA',
        flavor: 'animals need jobs too',
    },
    [track_ids.RUSH]: {
        title: 'Rush',
        artist: 'Troye Sivan',
        album: 'Something To Give Each Other',
        list: track_lists.THEME,
        audio: '/raw/audio/tracks/theme/rush_by_troye_sivan.mp3',
        image: '/raw/audio/tracks/theme/rush_troye_sivan.png',
        href: 'https://amazon.com/music/player/albums/B0C9PZG46V?marketplaceId=ATVPDKIKX0DER&musicTerritory=US&ref=dm_sh_pfsLeStmiShFCpE5R9fz1vXIx&trackAsin=B0C9PX4634',
        flavor: 'hi troye sivan',
    },
    // [track_ids.HEARTBEAT]: {
    //     title: 'Heartbeat',
    //     artist: 'Childish Gambino',
    //     album: 'Camp',
    //     list: track_lists.THEME,
    //     audio: '/raw/audio/tracks/theme/heartbeat_by_childish_gambino.mp3',
    //     image: '/raw/audio/tracks/theme/camp_by_childish_gambino.jpg',
    //     href: 'https://www.youtube.com/watch?v=dFVxGRekRSg',
    //     flavor: '<3',
    // },
    [track_ids.n3005]: {
        title: '3005',
        artist: 'Childish Gambino',
        album: 'Because the Internet',
        list: track_lists.THEME,
        audio: '/raw/audio/tracks/theme/3005_by_childish_gambino.mp3',
        image: '/raw/audio/tracks/theme/because_the_internet.jpeg',
        href: 'https://www.youtube.com/watch?v=tG35R8F2j8k',
        flavor: 'im going to live forever',
    },
    [track_ids.HELLO_SEATTLE]: {
        title: 'Hello Seattle',
        artist: 'Owl City',
        album: 'Ocean Eyes',
        list: track_lists.THEME,
        audio: '/raw/audio/tracks/theme/hello_seattle_by_owl_city.mp3',
        image: '/raw/audio/tracks/theme/ocean_eyes_by_owl_city.jpg',
        href: 'https://www.youtube.com/watch?v=7uvc46jujn8',
        flavor: 'animals need jobs too',
    },
    [track_ids.ITS_NICE_TO_BE_ALIVE]: {
        title: 'It\'s Nice To Be Alive',
        artist: 'Vegyn',
        album: '',
        list: track_lists.THEME,
        audio: '/raw/audio/tracks/theme/its_nice_to_be_alive_by_vegyn.mp3',
        image: '/raw/audio/tracks/theme/its_nice_to_be_alive_by_vegyn.jpg',
        href: 'https://vegyn.bandcamp.com/track/its-nice-to-be-alive',
        flavor: 'im going to live forever',
    },
    [track_ids.RADIO]: {
        title: 'Radio',
        artist: 'Sylvan Esso',
        album: 'What Now',
        list: track_lists.THEME,
        audio: '/raw/audio/tracks/theme/radio_sylvan_esso.mp3',
        image: '/raw/audio/tracks/theme/radio_sylvan_esso.jpg',
        href: 'https://sylvanesso.bandcamp.com/track/radio-2',
        flavor: 'website'
    },
    [track_ids.THE_LESS_I_KNOW_THE_BETTER]: {
        title: 'The Less I Know The Better',
        artist: 'Tame Impala',
        album: 'Currents',
        list: track_lists.THEME,
        audio: '/raw/audio/tracks/theme/the_less_i_know_the_better_by_tame_impala.mp3',
        image: '/raw/audio/tracks/theme/currents_by_tame_impala.jpeg',
        href: 'https://amazon.com/music/player/albums/B00WO1YR7K?marketplaceId=ATVPDKIKX0DER&musicTerritory=US&ref=dm_sh_vcxYBZnlz6U1m1ym3qTKLrHZP&trackAsin=B00WO1ZC2O',
        flavor: 'i know too much',
    },
    [track_ids.FRENESI]: {
        title: 'Frenesi',
        artist: 'Machine Girl',
        album: 'WLFGRL',
        list: track_lists.THEME,
        audio: '/raw/audio/tracks/theme/frenesi_by_machine_girl.mp3',
        image: '/raw/audio/tracks/theme/frenesi_by_machine_girl.jpg',
        href: 'https://dredcollective.bandcamp.com/track/machine-girl-gabbertrap-mix-frenesi-remix',
        flavor: 'machine guy',
    },
    /*
    [track_ids.]: {
        title: '',
        artist: '',
        album: '',
        list: track_lists.THEME,
        audio: '',
        image: '',
        href: '',
        flavor: '',
    },
    */
    [track_ids.ALL_THE_THINGS_SHE_SAID]: {
        title: 'All The Things She Said',
        artist: 'Poppy',
        album: undefined,
        list: track_lists.THEME,
        audio: '/raw/audio/tracks/theme/all_the_things_she_said.mp3',
        image: '/raw/audio/tracks/theme/all_the_things_she_said.jpg',
        href: 'https://open.spotify.com/track/0wH55ChKuoZkmGhbIYtOI4?si=156e9b9c68794f80',
        flavor: 'all the clicks (i track each one)',
    },
    // [track_ids.ANGELS]: {
    //     title: 'Angels',
    //     artist: 'The xx',
    //     album: undefined,
    //     list: track_lists.THEME,
    //     audio: '/raw/audio/tracks/theme/angels.mp3',
    //     image: '/raw/audio/tracks/theme/angels.jpg',
    //     href: 'https://open.spotify.com/track/1zuKjpp4t7BS8JPKi6mkQr?si=79a474e2b8504472',
    //     flavor: 'born in LA! jk :/',
    // },
    [track_ids.BEAUTIFUL]: {
        title: 'Beautiful',
        artist: 'Rhye',
        album: undefined,
        list: track_lists.THEME,
        audio: '/raw/audio/tracks/theme/beautiful.mp3',
        image: '/raw/audio/tracks/theme/beautiful.jpg',
        href: 'https://rhyemusic.bandcamp.com/album/beautiful',
        flavor: 'so beautiful',
    },
    [track_ids.CLOVERS]: {
        title: 'Clovers',
        artist: 'Barrie',
        album: undefined,
        list: track_lists.THEME,
        audio: '/raw/audio/tracks/theme/clovers.mp3',
        image: '/raw/audio/tracks/theme/clovers.jpg',
        href: 'https://open.spotify.com/track/20pGTJQx9VkRrW7Pvw5R2m?si=27042b52aefc44e2',
        flavor: 'a 4-leaf clover',
    },
    [track_ids.DEEP_SEA]: {
        title: 'Deep Sea',
        artist: 'Snail Mail',
        album: undefined,
        list: track_lists.THEME,
        audio: '/raw/audio/tracks/theme/deep_sea.mp3',
        image: '/raw/audio/tracks/theme/deep_sea.jpg',
        href: 'https://open.spotify.com/track/3MqVcAd41C9pC4RoS3IV1j?si=5c183a5a37e0421d',
        flavor: 'i love marine bio',
    },
    [track_ids.DOSES_AND_MIMOSAS]: {
        title: 'Doses & Mimosas',
        artist: 'Cherub',
        album: undefined,
        list: track_lists.THEME,
        audio: '/raw/audio/tracks/theme/doses_and_mimosas.mp3',
        image: '/raw/audio/tracks/theme/doses_and_mimosas.jpg',
        href: 'https://open.spotify.com/track/44CZRkOxv7UItaAUmh8PgN?si=bb238ae51dd74c76',
        flavor: 'brunch?',
    },
    [track_ids.EVERYTHING_IS_EMBARRASSING]: {
        title: 'Everything Is Embarrassing',
        artist: 'Sky Ferreira',
        album: undefined,
        list: track_lists.THEME,
        audio: '/raw/audio/tracks/theme/everything_is_embarrassing.mp3',
        image: '/raw/audio/tracks/theme/everything_is_embarrassing.jpg',
        href: 'https://open.spotify.com/track/7j3nbSiaWphYU2cFgyQXd9?si=0cb1498f2d664654',
        flavor: 'a little embarrassing',
    },
    [track_ids.FANTASY]: {
        title: 'Fantasy',
        artist: 'STRFKR',
        album: undefined,
        list: track_lists.THEME,
        audio: '/raw/audio/tracks/theme/fantasy.mp3',
        image: '/raw/audio/tracks/theme/fantasy.jpg',
        href: 'https://open.spotify.com/track/0rh0VNi3ILEAdZVIzltaBX?si=3177ae124a214715',
        flavor: 'sci-fi',
    },
    [track_ids.FIELDS_OF_GOLD]: {
        title: 'Fields Of Gold',
        artist: 'Sting',
        album: undefined,
        list: track_lists.THEME,
        audio: '/raw/audio/tracks/theme/fields_of_gold.mp3',
        image: '/raw/audio/tracks/theme/fields_of_gold.jpg',
        href: 'https://open.spotify.com/track/1VI7sH93UcY0stZYVqvMoH?si=e1fc0009bfa6440a',
        flavor: 'web of gold',
    },
    // [track_ids.GIVE_IT_TO_ME_STRAIGHT]: {
    //     title: 'Give It To Me Straight',
    //     artist: 'Gus Dapperton',
    //     album: undefined,
    //     list: track_lists.THEME,
    //     audio: '/raw/audio/tracks/theme/give_it_to_me_straight.mp3',
    //     image: '/raw/audio/tracks/theme/give_it_to_me_straight.jpg',
    //     href: 'https://open.spotify.com/track/0K1WiEPee04d00CltQVcrT?si=62e516e522a94eac',
    //     flavor: 'im straight',
    // },
    [track_ids.HAUNTED]: {
        title: 'Haunted',
        artist: 'Laura Les',
        album: undefined,
        list: track_lists.THEME,
        audio: '/raw/audio/tracks/theme/haunted.mp3',
        image: '/raw/audio/tracks/theme/haunted.jpg',
        href: 'https://open.spotify.com/track/1toNKayLMeCcVlsLGXJl7n?si=f359cefab6834289',
        flavor: 'moon\'s haunted',
    },
    [track_ids.I_DONT_KNOW_YOU]: {
        title: 'I Don\'t Know You',
        artist: 'The Marias',
        album: undefined,
        list: track_lists.THEME,
        audio: '/raw/audio/tracks/theme/i_dont_know_you.mp3',
        image: '/raw/audio/tracks/theme/i_dont_know_you.jpg',
        href: 'https://open.spotify.com/track/4cJOLN346rtOty3UPACsao?si=8b235b06c5574b48',
        flavor: 'do i know you',
    },
    [track_ids.I_SAY_FEVER]: {
        title: 'I Say Fever',
        artist: 'Ramona Falls',
        album: undefined,
        list: track_lists.THEME,
        audio: '/raw/audio/tracks/theme/i_say_fever.mp3',
        image: '/raw/audio/tracks/theme/i_say_fever.jpg',
        href: 'https://open.spotify.com/track/0W1YtIKd2npLkP213C3gR0?si=7fdc531ccb10436d',
        flavor: 'i code code',
    },
    [track_ids.I_WISH_I_WAS_STEPHEN_MALKMUS]: {
        title: 'I Wish I Was Stephen Malkmus',
        artist: 'beabadoobee',
        album: undefined,
        list: track_lists.THEME,
        audio: '/raw/audio/tracks/theme/i_wish_i_was_stephen_malkmus.mp3',
        image: '/raw/audio/tracks/theme/i_wish_i_was_stephen_malkmus.jpg',
        href: 'https://open.spotify.com/track/0MXwuLvZU9cauIEXlMZcdC?si=b2313b7a643e4bda',
        flavor: 'i wish i was Dua Lipa',
    },
    // [track_ids.IF_YOURE_NOT_THE_ONE]: {
    //     title: 'If You\'re Not The One',
    //     artist: 'Daniel Bedingfield',
    //     album: undefined,
    //     list: track_lists.THEME,
    //     audio: '/raw/audio/tracks/theme/if_youre_not_the_one.mp3',
    //     image: '/raw/audio/tracks/theme/if_youre_not_the_one.jpg',
    //     href: 'https://open.spotify.com/track/4gJoAvFpDvaeqm2EKYGmhb?si=0127fa7e421647a6',
    //     flavor: 'neo is the one',
    // },
    [track_ids.ILLUSION]: {
        title: 'Illusion',
        artist: 'Dua Lipa',
        album: undefined,
        list: track_lists.THEME,
        audio: '/raw/audio/tracks/theme/illusion.mp3',
        image: '/raw/audio/tracks/theme/illusion.jpg',
        href: 'https://open.spotify.com/track/59xD5osEFsaNt5PXfIKUnX?si=db32ae1588b44cc5',
        flavor: 'i wish i was Dua Lipa',
    },
    [track_ids.IS_THIS_HOW_YOU_FEEL]: {
        title: 'Is This How You Feel?',
        artist: 'The Preatures',
        album: undefined,
        list: track_lists.THEME,
        audio: '/raw/audio/tracks/theme/is_this_how_you_feel.mp3',
        image: '/raw/audio/tracks/theme/is_this_how_you_feel.jpg',
        href: 'https://open.spotify.com/track/7ud2JzdO2ozova6lBcCRmR?si=ca1ac9f6551f4131',
        flavor: 'is this real',
    },
    [track_ids.LEAVE_ME_LIKE_THIS]: {
        title: 'Leave Me Like This',
        artist: 'Skrillex',
        album: undefined,
        list: track_lists.THEME,
        audio: '/raw/audio/tracks/theme/leave_me_like_this.mp3',
        image: '/raw/audio/tracks/theme/leave_me_like_this.jpg',
        href: 'https://open.spotify.com/track/6NRvZuFXn2ixp8YdzUvG5n?si=5fa283a2127748c8',
        flavor: 'don\'t leave',
    },
    [track_ids.MY_FAVORITE_FISH]: {
        title: 'My Favorite Fish',
        artist: 'Gus Dapperton',
        album: undefined,
        list: track_lists.THEME,
        audio: '/raw/audio/tracks/theme/my_favorite_fish.mp3',
        image: '/raw/audio/tracks/theme/my_favorite_fish.jpg',
        href: 'https://open.spotify.com/track/1bda1uGY3RK54S59aNq4f7?si=e129cfccda504091',
        flavor: 'my favorite website',
    },
    // [track_ids.NEW_RULES]: {
    //     title: 'New Rules',
    //     artist: 'Dua Lipa',
    //     album: undefined,
    //     list: track_lists.THEME,
    //     audio: '/raw/audio/tracks/theme/new_rules.mp3',
    //     image: '/raw/audio/tracks/theme/new_rules.jpg',
    //     href: 'https://open.spotify.com/track/6tF92PMv01Ug9Dh8Rmy6nH?si=e2718f51efcb4be8',
    //     flavor: 'new apps every month',
    // },
    [track_ids.OSAKA_LOOP_LINE]: {
        title: 'Osaka Loop Line',
        artist: 'Discovery',
        album: undefined,
        list: track_lists.THEME,
        audio: '/raw/audio/tracks/theme/osaka_loop_line.mp3',
        image: '/raw/audio/tracks/theme/osaka_loop_line.jpg',
        href: 'https://open.spotify.com/track/4H9FGIjS07wouhMIHNNjEb?si=bb324beb262647a8',
        flavor: 'if statements & for loops',
    },
    [track_ids.PUSH]: {
        title: 'Push',
        artist: 'Skrillex',
        album: undefined,
        list: track_lists.THEME,
        audio: '/raw/audio/tracks/theme/push.mp3',
        image: '/raw/audio/tracks/theme/push.jpg',
        href: 'https://open.spotify.com/track/29OFLlrrfKIEVwbVMTjBYe?si=2cb68d9c4eae408c',
        flavor: 'i grind every day',
    },
    [track_ids.RED]: {
        title: 'red',
        artist: 'KAI',
        album: undefined,
        list: track_lists.THEME,
        audio: '/raw/audio/tracks/theme/red.mp3',
        image: '/raw/audio/tracks/theme/red.jpg',
        href: 'https://open.spotify.com/track/5xjCG1XNmz5eWkYMLrGFZl?si=003435906cf14009',
        flavor: 'i\'ll give you anything u want',
    },
    [track_ids.SANTA_FE]: {
        title: 'Santa Fe',
        artist: 'Beirut',
        album: undefined,
        list: track_lists.THEME,
        audio: '/raw/audio/tracks/theme/santa_fe.mp3',
        image: '/raw/audio/tracks/theme/santa_fe.jpg',
        href: 'https://open.spotify.com/track/6c9t15M38cWxyt3uLnLfD8?si=e11ce105ad994f41',
        flavor: 'prov ri',
    },
    [track_ids.SEXY_TO_SOMEONE]: {
        title: 'Sexy to Someone',
        artist: 'Clairo',
        album: undefined,
        list: track_lists.THEME,
        audio: '/raw/audio/tracks/theme/sexy_to_someone.mp3',
        image: '/raw/audio/tracks/theme/sexy_to_someone.jpg',
        href: 'https://open.spotify.com/track/2Nq4SFbvYYZa8AF7lD7CWU?si=375b687769f34693',
        flavor: 'can a website be sexy',
    },
    // [track_ids.SOMEBODY_THAT_I_USED_TO_KNOW]: {
    //     title: 'Somebody That I Used To Know',
    //     artist: 'Gotye, Kimbra',
    //     album: undefined,
    //     list: track_lists.THEME,
    //     audio: '/raw/audio/tracks/theme/somebody_that_i_used_to_know.mp3',
    //     image: '/raw/audio/tracks/theme/somebody_that_i_used_to_know.jpg',
    //     href: 'https://open.spotify.com/track/4wCmqSrbyCgxEXROQE6vtV?si=9c7857b1c4344b12',
    //     flavor: 'KNOW ME BETTER',
    // },
    [track_ids.SPIT_IN_MY_FACE]: {
        title: 'SPIT IN MY FACE!',
        artist: 'ThxSoMch',
        album: undefined,
        list: track_lists.THEME,
        audio: '/raw/audio/tracks/theme/spit_in_my_face.mp3',
        image: '/raw/audio/tracks/theme/spit_in_my_face.jpg',
        href: 'https://open.spotify.com/track/1N8TTK1Uoy7UvQNUazfUt5?si=82d7378e96304e65',
        flavor: 'USE MY WEBSITE!',
    },
    [track_ids.THE_PERFECT_GIRL]: {
        title: 'The Perfect Girl',
        artist: 'Mareux',
        album: undefined,
        list: track_lists.THEME,
        audio: '/raw/audio/tracks/theme/the_perfect_girl.mp3',
        image: '/raw/audio/tracks/theme/the_perfect_girl.jpg',
        href: 'https://open.spotify.com/track/5RBOcBpJXaNnHCGViJmYhh?si=370a57dc5fba4294',
        flavor: 'the perfect website',
    },
    [track_ids.VAMPIRE_EMPIRE]: {
        title: 'Vampire Empire',
        artist: 'Big Thief',
        album: undefined,
        list: track_lists.THEME,
        audio: '/raw/audio/tracks/theme/vampire_empire.mp3',
        image: '/raw/audio/tracks/theme/vampire_empire.jpg',
        href: 'https://open.spotify.com/track/0ToG55iJZCOzZkcpWbXxpW?si=ebf6575d828d4489',
        flavor: 'thanks Obama',
    },
    [track_ids.WHEN_AM_I_GONNA_LOSE_YOU]: {
        title: 'When Am I Gonna Lose You',
        artist: 'Local Natives',
        album: undefined,
        list: track_lists.THEME,
        audio: '/raw/audio/tracks/theme/when_am_i_gonna_lose_you.mp3',
        image: '/raw/audio/tracks/theme/when_am_i_gonna_lose_you.jpg',
        href: 'https://open.spotify.com/track/7ze7X8r4fopBs9ZRtwYFOX?si=f9ea0b87a9204c53',
        flavor: 'user retention',
    },
    [track_ids.WHEN_I_GET_HOME]: {
        title: 'When I Get Home',
        artist: 'Post Animal',
        album: undefined,
        list: track_lists.THEME,
        audio: '/raw/audio/tracks/theme/when_i_get_home.mp3',
        image: '/raw/audio/tracks/theme/when_i_get_home.jpg',
        href: 'https://open.spotify.com/track/1R06KfLRjBFEh7S1cmLfWk?si=31ce4a2252b04dc7',
        flavor: 'i live here',
    },

    // [track_ids.STARRY_NIGHT]: {
    //     title: 'Starry Night',
    //     artist: 'Peggy Gou',
    //     album: undefined,
    //     list: track_lists.THEME,
    //     audio: '/raw/audio/tracks/theme/starry_night.mp3',
    //     image: '/raw/audio/tracks/theme/starry_night.jpg',
    //     href: 'https://peggygou.bandcamp.com/track/starry-night',
    //     flavor: 'cyrus means \'the sun\'',
    // },
    [track_ids.YOURE_THE_ONE]: {
        title: 'YOU\'RE THE ONE',
        artist: 'Kaytranada',
        album: undefined,
        list: track_lists.THEME,
        audio: '/raw/audio/tracks/theme/youre_the_one.mp3',
        image: '/raw/audio/tracks/theme/youre_the_one.jpg',
        href: 'https://open.spotify.com/track/2b4SSorCTQ2VzmllaeWuuT?si=b683740a86b9452e',
        flavor: 'god i love The Matrix',
    },

    [track_ids.NULL]: {
        title: 'Ø',
        artist: 'Lorn',
        album: undefined,
        list: track_lists.THEME,
        audio: '/raw/audio/tracks/theme/null_by_lorn.mp3',
        image: '/raw/audio/tracks/theme/null_by_lorn.jpg',
        href: 'https://ofdreamforever.bandcamp.com/track/-',
        flavor: 'null',
    },
    [track_ids.SUPERSONIC]: {
        title: 'Supersonic (my existence)',
        artist: 'Skrillex',
        album: undefined,
        list: track_lists.THEME,
        audio: '/raw/audio/tracks/theme/supersonic.mp3',
        image: '/raw/audio/tracks/theme/supersonic.jpg',
        href: 'https://www.youtube.com/watch?v=U41bONK2V-U',
        flavor: 'i code supersonic',
    },

    // 2026-03-05
    [track_ids.ASSIS]: {
        title: 'Assis',
        artist: 'spill tab',
        album: undefined,
        list: track_lists.THEME,
        audio: '/raw/audio/tracks/theme/2026-03/assis.mp3',
        image: '/raw/audio/tracks/theme/2026-03/assis.webp',
        href: 'https://spilltab.bandcamp.com/track/assis-1',
        flavor: 'the french (haha)',
    },
    [track_ids.BACK_OF_MY_MIND]: {
        title: 'back of my mind',
        artist: 'bad tuner, berryblue',
        album: undefined,
        list: track_lists.THEME,
        audio: '/raw/audio/tracks/theme/2026-03/back_of_my_mind.mp3',
        image: '/raw/audio/tracks/theme/2026-03/back_of_my_mind.jpg',
        href: 'https://badtuner.bandcamp.com/track/back-of-my-mind',
        flavor: 'a handful of blueberries',
    },
    [track_ids.BBYDOLL]: {
        title: 'bbydoll',
        artist: 'Aziya',
        album: undefined,
        list: track_lists.THEME,
        audio: '/raw/audio/tracks/theme/2026-03/bbydoll.mp3',
        image: '/raw/audio/tracks/theme/2026-03/bbydoll.jpg',
        href: 'https://open.spotify.com/track/2gnLLrNnITq04tguy716dt',
        flavor: 'adult man',
    },
    [track_ids.ESCALATOR]: {
        title: 'Escalator',
        artist: 'Ritt Momney',
        album: undefined,
        list: track_lists.THEME,
        audio: '/raw/audio/tracks/theme/2026-03/escalator.mp3',
        image: '/raw/audio/tracks/theme/2026-03/escalator.jpg',
        href: 'https://open.spotify.com/track/6VKha9kbRxUWQSx7eH7Rxw',
        flavor: 'escalators for sure freak me out a little bit',
    },
    [track_ids.LLTB]: {
        title: 'LLTB',
        artist: 'Jam City, Wet',
        album: undefined,
        list: track_lists.THEME,
        audio: '/raw/audio/tracks/theme/2026-03/lltb.mp3',
        image: '/raw/audio/tracks/theme/2026-03/lltb.jpg',
        href: 'https://open.spotify.com/track/1Ywt0ieG8EC4osUu1LkNzI',
        flavor: 'lettuce lettuce tomato bacon',
    },
    [track_ids.NEWJEANS]: {
        title: 'NEWJEANS - Sped Up',
        artist: 'Turtlecommercial',
        album: undefined,
        list: track_lists.THEME,
        audio: '/raw/audio/tracks/theme/2026-03/newjeans.mp3',
        image: '/raw/audio/tracks/theme/2026-03/newjeans.jpg',
        href: 'https://open.spotify.com/track/3rjtCjTPIkL4SeHMhQHzJ2',
        flavor: 'soothes the brain',
    },
    [track_ids.REFLEKTOR]: {
        title: 'Reflektor',
        artist: 'Arcade Fire',
        album: undefined,
        list: track_lists.THEME,
        audio: '/raw/audio/tracks/theme/2026-03/reflektor.mp3',
        image: '/raw/audio/tracks/theme/2026-03/reflektor.jpg',
        href: 'https://open.spotify.com/track/2LWMF10STZqYY9a3YqBiOG',
        flavor: 'ok this one is pretty long',
    },
    [track_ids.RUN_AWAY_MY_LOVER]: {
        title: 'Run Away, My Lover - wev Remix',
        artist: 'FiFi Zhang, wev',
        album: undefined,
        list: track_lists.THEME,
        audio: '/raw/audio/tracks/theme/2026-03/run_away_my_lover.mp3',
        image: '/raw/audio/tracks/theme/2026-03/run_away_my_lover.jpg',
        href: 'https://open.spotify.com/track/1ewpNE1k2HVtlmaXZ64K6p',
        flavor: 'i love someone!',
    },
    // [track_ids.SYNESTHESIA]: {
    //     title: 'synesthesia!',
    //     artist: 'Deko, Yameii Online',
    //     album: undefined,
    //     list: track_lists.THEME,
    //     audio: '/raw/audio/tracks/theme/2026-03/synesthesia.mp3',
    //     image: '/raw/audio/tracks/theme/2026-03/synesthesia.jpg',
    //     href: 'https://open.spotify.com/track/5vM8YrpSt5PH7usWXzJqgQ',
    //     flavor: 'tbh this one is annoying',
    // },
    [track_ids.BABY_MY_PHONE]: {
        title: 'Baby My Phone',
        artist: 'Yameii Online',
        album: undefined,
        list: track_lists.THEME,
        audio: '/raw/audio/tracks/theme/2026-03/baby_my_phone.mp3',
        image: '/raw/audio/tracks/theme/2026-03/baby_my_phone.jpg',
        href: 'https://open.spotify.com/track/2SjvBmZYIbQTJ7rrPgdmV8',
        flavor: 'every human needs an iphone',
    },
    [track_ids.TESSELLATE]: {
        title: 'Tessellate',
        artist: 'alt-J',
        album: undefined,
        list: track_lists.THEME,
        audio: '/raw/audio/tracks/theme/2026-03/tessellate.mp3',
        image: '/raw/audio/tracks/theme/2026-03/tessellate.png',
        href: 'https://open.spotify.com/track/1o22EcqsCANhwYdaNOSdwS',
        flavor: 'fractalize, combobulate',
    },
    [track_ids.TIGHT_DRESS]: {
        title: 'Tight Dress',
        artist: 'Kaila',
        album: undefined,
        list: track_lists.THEME,
        audio: '/raw/audio/tracks/theme/2026-03/tight_dress.mp3',
        image: '/raw/audio/tracks/theme/2026-03/tight_dress.jpg',
        href: 'https://open.spotify.com/track/0VSnVU4YP5YJ6zZXuMoOBs',
        flavor: 'tight website',
    },
    [track_ids.UNWRITTEN]: {
        title: 'Unwritten',
        artist: 'Natasha Bedingfield',
        album: undefined,
        list: track_lists.THEME,
        audio: '/raw/audio/tracks/theme/2026-03/unwritten.mp3',
        image: '/raw/audio/tracks/theme/2026-03/unwritten.jpg',
        href: 'https://open.spotify.com/track/3U5JVgI2x4rDyHGObzJfNf',
        flavor: 'absolutely written. toiled over',
    },
    [track_ids.DISCO]: {
        title: 'Disco',
        artist: 'Surf Curse',
        album: undefined,
        list: track_lists.THEME,
        audio: '/raw/audio/tracks/theme/2026-03/disco.mp3',
        image: '/raw/audio/tracks/theme/2026-03/disco.png',
        href: 'https://surfcurse.bandcamp.com/track/disco',
        flavor: 'surf blessing',
    },
    [track_ids.ACETONE]: {
        title: 'Acetone',
        artist: 'Vundabar',
        album: undefined,
        list: track_lists.THEME,
        audio: '/raw/audio/tracks/theme/2026-03/acetone.mp3',
        image: '/raw/audio/tracks/theme/2026-03/acetone.jpg',
        href: 'https://open.spotify.com/track/2acA2q7K4PnAkF8SHcp4JW',
        flavor: 'caffeine',
    },
    [track_ids.FALL_IN_LOVE]: {
        title: 'Fall In Love',
        artist: 'Phantogram',
        album: undefined,
        list: track_lists.THEME,
        audio: '/raw/audio/tracks/theme/2026-03/fall_in_love.mp3',
        image: '/raw/audio/tracks/theme/2026-03/fall_in_love.jpg',
        href: 'https://open.spotify.com/track/73FCPll1CK0sklAt1VlmFc',
        flavor: 'i love someone!',
    },
    [track_ids.PARKING_LOT]: {
        title: 'Parking Lot',
        artist: 'Hana Vu',
        album: undefined,
        list: track_lists.THEME,
        audio: '/raw/audio/tracks/theme/2026-03/parking_lot.mp3',
        image: '/raw/audio/tracks/theme/2026-03/parking_lot.jpg',
        href: 'https://hanavu.bandcamp.com/track/parking-lot',
        flavor: 'park ya cah in hahvahd yahd',
    },
    [track_ids.INTERMISSION]: {
        title: 'Intermission',
        artist: 'Strawberry Guy',
        album: undefined,
        list: track_lists.THEME,
        audio: '/raw/audio/tracks/theme/2026-03/intermission.mp3',
        image: '/raw/audio/tracks/theme/2026-03/intermission.jpg',
        href: 'https://open.spotify.com/track/4hm33jVolpa22nzhlY72jD',
        flavor: 'guy',
    },
    [track_ids.DONT_TAKE_THE_MONEY]: {
        title: 'Don\'t Take The Money',
        artist: 'Bleachers',
        album: undefined,
        list: track_lists.THEME,
        audio: '/raw/audio/tracks/theme/2026-03/dont_take_the_money.mp3',
        image: '/raw/audio/tracks/theme/2026-03/dont_take_the_money.jpg',
        href: 'https://open.spotify.com/track/0d3BJRrklQ6sTfbmrojuZI',
        flavor: '2022: Amazon. 2026: this',
    },
    [track_ids.HEAVEN_HELL]: {
        title: 'Heaven/Hell',
        artist: 'CHVRCHES',
        album: undefined,
        list: track_lists.THEME,
        audio: '/raw/audio/tracks/theme/2026-03/heaven_hell.mp3',
        image: '/raw/audio/tracks/theme/2026-03/heaven_hell.jpg',
        href: 'https://open.spotify.com/track/0C2TcipR9L15Hy6kkINmu1',
        flavor: 'holy hell',
    },
    [track_ids.FIFTEEN_STEP]: {
        title: '15 Step',
        artist: 'Radiohead',
        album: undefined,
        list: track_lists.THEME,
        audio: '/raw/audio/tracks/theme/2026-03/fifteen_step.mp3',
        image: '/raw/audio/tracks/theme/2026-03/fifteen_step.jpg',
        href: 'https://open.spotify.com/track/6dsq7Nt5mIFzvm5kIYNORy',
        flavor: 'math rocks',
    },
    [track_ids.TRAVELING_AT_THE_SPEED_OF_LIGHT]: {
        title: 'Traveling At The Speed Of Light',
        artist: 'Joywave',
        album: undefined,
        list: track_lists.THEME,
        audio: '/raw/audio/tracks/theme/2026-03/traveling_at_the_speed_of_light.mp3',
        image: '/raw/audio/tracks/theme/2026-03/traveling_at_the_speed_of_light.jpg',
        href: 'https://open.spotify.com/track/5zZOhHw2p7VLPau3A29hJw',
        flavor: 'maxxing E[lightcone]',
    },
    [track_ids.SLIP_AWAY]: {
        title: 'Slip Away',
        artist: 'Perfume Genius',
        album: undefined,
        list: track_lists.THEME,
        audio: '/raw/audio/tracks/theme/2026-03/slip_away.mp3',
        image: '/raw/audio/tracks/theme/2026-03/slip_away.jpg',
        href: 'https://open.spotify.com/track/6rdPOO6QBwbDwfBJrXkb3S',
        flavor: 'actual genius',
    },
    [track_ids.GO]: {
        title: 'Go!',
        artist: 'M83, MAI LAN',
        album: undefined,
        list: track_lists.THEME,
        audio: '/raw/audio/tracks/theme/2026-03/go.mp3',
        image: '/raw/audio/tracks/theme/2026-03/go.jpg',
        href: 'https://ilovem83.bandcamp.com/track/go',
        flavor: 'javascript!',
    },
    [track_ids.CALIFORNIA_DREAMIN]: {
        title: 'California Dreamin\'',
        artist: 'The Mamas & The Papas',
        album: undefined,
        list: track_lists.THEME,
        audio: '/raw/audio/tracks/theme/2026-03/california_dreamin.mp3',
        image: '/raw/audio/tracks/theme/2026-03/california_dreamin.jpg',
        href: 'https://open.spotify.com/track/4s6LhHAV5SEsOV0lC2tjvJ',
        flavor: 'prov ri > california',
    },
    [track_ids.CIAO]: {
        title: 'Ciao',
        artist: 'Yaeger',
        album: undefined,
        list: track_lists.THEME,
        audio: '/raw/audio/tracks/theme/2026-03/ciao.mp3',
        image: '/raw/audio/tracks/theme/2026-03/ciao.png',
        href: 'https://open.spotify.com/track/2tXILArq64JkwKB1G2wstD',
        flavor: 'don\'t leave',
    },
    [track_ids.IPHONE]: {
        title: 'IPHONE',
        artist: 'Rico Nasty',
        album: undefined,
        list: track_lists.THEME,
        audio: '/raw/audio/tracks/theme/2026-03/iphone.mp3',
        image: '/raw/audio/tracks/theme/2026-03/iphone.jpg',
        href: 'https://open.spotify.com/track/2dMvqE5MHPH7Ksd5pQqFmL',
        flavor: 'every human needs an iphone',
    },
    [track_ids.LET_U_GO]: {
        title: 'Let U Go',
        artist: 'lucidbeatz',
        album: undefined,
        list: track_lists.THEME,
        audio: '/raw/audio/tracks/theme/2026-03/let_u_go.mp3',
        image: '/raw/audio/tracks/theme/2026-03/let_u_go.jpg',
        href: 'https://open.spotify.com/track/40TZnaw4eDPChJNHw2Swf3',
        flavor: 'don\'t leave',
    },
    [track_ids.MAKE_YOU_MINE]: {
        title: 'make you mine',
        artist: 'Madison Beer',
        album: undefined,
        list: track_lists.THEME,
        audio: '/raw/audio/tracks/theme/2026-03/make_you_mine.mp3',
        image: '/raw/audio/tracks/theme/2026-03/make_you_mine.png',
        href: 'https://open.spotify.com/track/48vIfHaK7by6x0T6ucpODL',
        flavor: 'please god donate $2/mo',
    },
    [track_ids.MONTAGEM_MYSTERIOUS_GAME]: {
        title: 'Montagem Mysterious Game',
        artist: 'LXNGVX',
        album: undefined,
        list: track_lists.THEME,
        audio: '/raw/audio/tracks/theme/2026-03/montagem_mysterious_game.mp3',
        image: '/raw/audio/tracks/theme/2026-03/montagem_mysterious_game.jpg',
        href: 'https://open.spotify.com/track/7vOmSP2647oNUGGEhWd1cr',
        flavor: 'i love board games',
    },
    [track_ids.VON_DUTCH]: {
        title: 'Von dutch',
        artist: 'Charli xcx',
        album: undefined,
        list: track_lists.THEME,
        audio: '/raw/audio/tracks/theme/2026-03/von_dutch.mp3',
        image: '/raw/audio/tracks/theme/2026-03/von_dutch.jpg',
        href: 'https://open.spotify.com/track/01TnMXIy7mJJQ7E8uy937N',
        flavor: 'von american',
    },
    [track_ids.ADVENTURE_OF_A_LIFETIME]: {
        title: 'Adventure Of A Lifetime',
        artist: 'Coldplay',
        album: undefined,
        list: track_lists.THEME,
        audio: '/raw/audio/tracks/theme/2026-03/adventure_of_a_lifetime.mp3',
        image: '/raw/audio/tracks/theme/2026-03/adventure_of_a_lifetime.jpg',
        href: 'https://open.spotify.com/track/69uxyAqqPIsUyTO8txoP2M',
        flavor: 'we\'re going to save the world',
    },
    [track_ids.EASY]: {
        title: 'EASY',
        artist: 'LE SSERAFIM',
        album: undefined,
        list: track_lists.THEME,
        audio: '/raw/audio/tracks/theme/2026-03/easy.mp3',
        image: '/raw/audio/tracks/theme/2026-03/easy.png',
        href: 'https://open.spotify.com/track/2O4Bb2WCkjlTPO827OnBMI',
        flavor: 'my favorite song',
    },
    [track_ids.EMPIRE_ANTS]: {
        title: 'Empire Ants',
        artist: 'Gorillaz, Little Dragon',
        album: undefined,
        list: track_lists.THEME,
        audio: '/raw/audio/tracks/theme/2026-03/empire_ants.mp3',
        image: '/raw/audio/tracks/theme/2026-03/empire_ants.jpg',
        href: 'https://open.spotify.com/track/3a6PN6BRB8PP3ms48s7kU1',
        flavor: 'animals need jobs too',
    },
    [track_ids.FILLE]: {
        title: 'FILLE',
        artist: 'Cannelle',
        album: undefined,
        list: track_lists.THEME,
        audio: '/raw/audio/tracks/theme/2026-03/fille.mp3',
        image: '/raw/audio/tracks/theme/2026-03/fille.jpg',
        href: 'https://open.spotify.com/track/3rqyWkpY4Qx3HVsryAOcFu',
        flavor: 'just listen to this one',
    },
    [track_ids.FIRE_FLIES]: {
        title: 'Fire Flies',
        artist: 'Gorillaz',
        album: undefined,
        list: track_lists.THEME,
        audio: '/raw/audio/tracks/theme/2026-03/fire_flies.mp3',
        image: '/raw/audio/tracks/theme/2026-03/fire_flies.webp',
        href: 'https://open.spotify.com/track/4A5FLaZI3Ni5eT0c9fqi8F',
        flavor: 'animals need jobs too',
    },
    [track_ids.GIVE_IT_TO_ME_STRAIGHT]: {
        title: 'Give It To Me Straight',
        artist: 'Gus Dapperton',
        album: undefined,
        list: track_lists.THEME,
        audio: '/raw/audio/tracks/theme/2026-03/give_it_to_me_straight.mp3',
        image: '/raw/audio/tracks/theme/2026-03/give_it_to_me_straight.jpg',
        href: 'https://open.spotify.com/track/0K1WiEPee04d00CltQVcrT',
        flavor: 'please god donate $2/mo',
    },
    [track_ids.ILLIT]: {
        title: 'Magnetic',
        artist: 'ILLIT',
        album: undefined,
        list: track_lists.THEME,
        audio: '/raw/audio/tracks/theme/2026-03/illit.mp3',
        image: '/raw/audio/tracks/theme/2026-03/illit.jpg',
        href: 'https://open.spotify.com/track/1aKvZDoLGkNMxoRYgkckZG',
        flavor: 'electronic',
    },
    [track_ids.WANA]: {
        title: 'Wana',
        artist: 'nour',
        album: undefined,
        list: track_lists.THEME,
        audio: '/raw/audio/tracks/theme/2026-03/wana.mp3',
        image: '/raw/audio/tracks/theme/2026-03/wana.jpg',
        href: 'https://open.spotify.com/track/6ygaR0OCPjB2YdBbbNKvss',
        flavor: 'wana get brunch?',
    },
    [track_ids.GNARLY]: {
        title: 'Gnarly',
        artist: 'KATSEYE',
        album: undefined,
        list: track_lists.THEME,
        audio: '/raw/audio/tracks/theme/2026-03/gnarly.mp3',
        image: '/raw/audio/tracks/theme/2026-03/gnarly.jpg',
        href: 'https://open.spotify.com/track/1j15Ar0qGDzIR0v3CQv3JL',
        flavor: 'stand for liberty',
    },
    [track_ids.INFINITE_CITIES]: {
        title: 'Infinite Cities',
        artist: 'The Bright Light Social Hour',
        album: undefined,
        list: track_lists.THEME,
        audio: '/raw/audio/tracks/theme/2026-03/infinite_cities.mp3',
        image: '/raw/audio/tracks/theme/2026-03/infinite_cities.jpg',
        href: 'https://open.spotify.com/track/514ybzbNgtXoW106pAUDZo',
        flavor: 'heaven is a state of mind',
    },
    [track_ids.I_LOVE_IT]: {
        title: 'I Love It',
        artist: 'Icona Pop, Charli xcx',
        album: undefined,
        list: track_lists.THEME,
        audio: '/raw/audio/tracks/theme/2026-03/i_love_it.mp3',
        image: '/raw/audio/tracks/theme/2026-03/i_love_it.png',
        href: 'https://open.spotify.com/track/6HZ9VeI5IRFCNQLXhpF4bq',
        flavor: 'song of the summer',
    },
}
Object.entries(tracks).map(([id, track]) => track.id = id)

export const get_tracks = (list:string|string[]): track[] => {
    if (typeof(list) === 'string') {
        return values(tracks).filter(track => track.list === list)
    } else {
        return list.map(id => tracks[id]).filter(x=>x)
    }
}

const EMPTY_TRACK = '/raw/audio/tracks/2-seconds-of-silence.mp3'
export const TRACK_PLAYER_COOKIE = {
    STATE: 'music-player-state',
}
let play_success = false
let first_track_shown = false
let player_scope: ResourceScope
let track_scope: ResourceScope
const state: {
    node: any,
    inited: boolean,
    tracks: track[], order?: number[],
    index: number,
    paused: boolean,
    off: boolean,
    currentTime?: number,
} = {
    node: undefined,
    inited: false,
    tracks: [],
    index: -1,
    paused: false,
    off: true,
    currentTime: 0,
}
const save_track_player_state = () => {
    // Publish playback changes for reactive components, including Base flavor text.
    store.set(TRACK_PLAYER_COOKIE.STATE, {
        off: state.off,
        paused: state.paused,
        index: state.index,
    })
}
export const get_current_track = () => state.tracks[state.order ? state.order[state.index % state.tracks.length] : state.index % state.tracks.length]

let last_track_hide_timeout = undefined
window['_track_player_message'] = message
export const create_track_show = ({do_play_without_click=true}={}) => {
    return () => {
        const track = get_current_track()
        if (!track) return
        message.trigger({ delete: 'track-player-toggle track-player-notification' })
        message.trigger({
            // html: `<div class='row' style='gap:.5em'>
            //     <a onclick="
            //     if (${!state.off}) event.stopPropagation()
            //     const off = music_off(${!state.off}) // || defer(() => _track_player_curr_show_track_info(), 500)
            //     _track_player_message.trigger({ delete: off ? 'track-player-notification track-player-toggle' : 'track-player-toggle' })
            //     ">${state.off ? 'enable' : 'disable'} music</a>
            // </div>`,
            html: `<div class='row' style='gap:.5em'>
                <a onclick="
                if (${!state.off}) event.stopPropagation()
                const off = music_off(null, true) // || defer(() => next_track(), 500)
                // _track_player_message.trigger({ delete: off ? 'track-player-notification track-player-toggle' : 'track-player-toggle' })
                if (off) {
                    _track_player_message.trigger({ delete: 'track-player-notification track-player-toggle' })
                } else {
                    window['create_track_show']()()
                }
                ">${state.off ? 'play' : 'disable'} music</a>
            </div>`,
            id: 'track-player-toggle', delete: 'track-player-toggle',
            // ms: 5_000,
        })
        message.trigger({
            html: `<div class='row' style='gap:.5em; max-width: calc(100vw - 5rem)'>
                <img src='${track.image}' style="width:3em"></img>
                <div class='column' style="overflow: auto">
                    <div style="
                    white-space: nowrap;
                    // max-width: 15em;
                    text-overflow: ellipsis;
                    overflow: hidden;
                    "><a target='_blank' href='${track.href}'>${track.title}</a></div>
                    <div>${track.artist}</div>
                </div>
                ${state.off && 0 ? '' : `<div class='column' style='flex-shrink:0; padding-left:.5em; border-left: 1px solid #8884'>
                    <span>${track.list}</span>
                    ${state.off || do_play_without_click ? `<span class="row wide end gap" style="user-select:none"><a style="display:none;text-decoration:none;border:none" onclick="
                    music_off(null, true)
                    ">⏯</a><a style="text-decoration:none;border:none" onclick="
                    next_track()
                    ">⏭︎</a></span>` : `<span style='opacity:.5'>(after click)</span>`}
                </div>`}
            </div>`,
            id: 'track-player-notification', delete: 'track-player-notification',
            // ms: is_mobile ? 5_000 : undefined,
        })
        if (last_track_hide_timeout) clearTimeout(last_track_hide_timeout)
        last_track_hide_timeout = setTimeout(() => {
            if (is_mobile || state.off) {
                message.trigger({ delete: 'track-player-toggle track-player-notification' })
            }
            last_track_hide_timeout = undefined
        }, 5_000)
    }
}
window['show_track'] = create_track_show()
window['create_track_show'] = create_track_show

export const shuffle_tracks = window['shuffle_tracks'] = () => {
    if (state.tracks.length > 0) {
        state.order = rand.shuffle_order(state.tracks.length)
        state.index -= 1 // decrement so next_track plays the "current" position
        save_track_player_state()
        log('shuffle_tracks', state.order)
        next_track() // start playing the track at current position in new order
    }
}

export const music_off = window['music_off'] = (off=true, toggle=false) => {
    off = toggle ? !state.off : off
    state.inited = true
    state.off = state.paused = off
    save_track_player_state()
    if (state.off) {
        state.node?.pause()
    } else {
        state.node?.play()?.catch(error => log('play failed', error?.message || String(error)))
        // defer(() => state.node.play(), 500) // IDK WHY THIS IS NEEDED BUT IT IS UGHH
    }
    // Update Media Session playback state
    if ('mediaSession' in navigator) {
        navigator.mediaSession.playbackState = state.off ? 'paused' : 'playing'
    }
    log('music_off', { off: state.off, paused: state.node?.paused })
    return state.off
}

export const next_track = window['next_track'] = () => {
    track_scope?.dispose()
    const scope = track_scope = player_scope?.active ? player_scope.child() : createResourceScope()
    state.index += 1
    const track = get_current_track()
    if (track) {
        // Retain the original next-tick source update; obsolete requests own
        // and cancel that tick instead of changing a later track's source.
        scope.timeout(() => {
            const audio = state.node
            if (!audio) return
            scope.listen(audio, 'canplay', () => {
                const do_play_without_click = play_success || state.inited
                if (do_play_without_click) {
                    state.off || music_off(false)
                } else if (!state.off) {
                    scope.listen(window, 'click', () => {
                        state.off || music_off(false)
                        play_success = true
                        message.trigger({ delete: 'track-player-notification track-player-toggle' })
                    }, { once: true })
                }
                window['_track_player_curr_show_track_info'] = next_track
                window['_track_player_message'] = message

                // Preload as before, but artwork belongs to this track request.
                if ('mediaSession' in navigator && typeof MediaMetadata === 'function') {
                    const image_src = track.image.startsWith('/') ? window.location.origin + track.image : track.image
                    const artwork = scope.child()
                    const img = new Image()
                    artwork.own(() => img.removeAttribute('src'))
                    artwork.listen(img, 'load error', () => {
                        try {
                            navigator.mediaSession.metadata = new MediaMetadata({
                                title: track.flavor || track.title,
                                artist: track.artist,
                                album: track.album || track.list,
                                artwork: [{ src: image_src, sizes: '512x512', type: 'image/jpeg' }],
                            })
                        } finally { artwork.dispose() }
                    })
                    img.src = image_src
                }
                if (!is_mobile || first_track_shown) create_track_show({ do_play_without_click })()
                first_track_shown = true
            }, { once: true })
            audio.src = track.audio
        }, 1)
    } else {
        state.node?.pause()
        if (state.node) state.node.src = ''
    }
}
export const track_play = (list:string|string[], {do_shuffle=false,do_first_shuffle=false}={}) => {
    state.tracks = get_tracks(list)
    state.order = do_shuffle || do_first_shuffle ? rand.shuffle_order(state.tracks.length) : undefined
    state.index = -1
    log('track_play', {list, do_shuffle, do_first_shuffle})
    state.inited = true
    next_track()
}
export const DropdownTrackPlayerFill = () => {
    const rerender = useRerender()
    const [time, set_time] = useS(0)
    useE(() => {
        return on(state.node, 'timeupdate', () => {
            if (!state.paused) set_time(state.node.currentTime)
        })
    })
    useE(() => {
        return on(state.node, 'canplay', () => {
            if (!state.paused) set_time(state.node.currentTime)
        })
    })

    const track = get_current_track()
    const total_time = state.node?.duration
    const render_time = (ms) => `${Math.floor(ms / 60).toString().padStart(2, '0')}:${Math.floor(ms % 60).toString().padStart(2, '0')}`

    return track ? <>
        <span style={S(`
        max-width: 15em;
        text-overflow: ellipsis;
        overflow: hidden;
        `)}>{track.title}</span>
        <span>{render_time(time)}{total_time ? <> / {render_time(total_time)}</> : null}</span>
        <span><a onClick={e => {
            state.paused = !state.node?.paused
            save_track_player_state()
            if (state.paused) {
                state.node.pause()
            } else {
                state.off || state.node.play()
            }
            rerender()
        }}>{state.node?.paused ? 'unpause' : 'pause'}</a> / <a onClick={e => {
            state.paused = false
            next_track()
        }}>next</a></span>
        <hr/>
    </> : null
}
export const GlobalTrackPlayer = () => {
    useE(() => {
        player_scope?.dispose()
        const scope = player_scope = createResourceScope()
        try {
            state.inited = false
            state.paused = true
            save_track_player_state()
            const outer_node = node('<div><div><div><audio /></div></div></div>')
            const audio = state.node = Q(outer_node, 'audio')
            scope.own([
                () => audio.pause(),
                () => { audio.removeAttribute('src'); audio.load() },
                () => outer_node.remove(),
                () => { if (player_scope === scope) {
                    track_scope?.dispose()
                    track_scope = player_scope = undefined
                    state.node = undefined
                    clearTimeout(last_track_hide_timeout)
                    last_track_hide_timeout = undefined
                    message.trigger({ delete: 'track-player-toggle track-player-notification' })
                    if ('mediaSession' in navigator) {
                        navigator.mediaSession.metadata = null
                        navigator.mediaSession.playbackState = 'none'
                    }
                } },
            ])
            audio.src = EMPTY_TRACK
            scope.listen(audio, 'ended', () => next_track())
            scope.listen(audio, 'timeupdate', () => {
                if ('mediaSession' in navigator && audio.duration) {
                    try {
                        navigator.mediaSession.setPositionState({
                            duration: audio.duration,
                            playbackRate: audio.playbackRate,
                            position: audio.currentTime,
                        })
                    } catch {}
                }
            })
            document.body.append(outer_node)
            audio.play().then(scope.guard(() => { play_success = true })).catch(() => {})

            if ('mediaSession' in navigator && typeof navigator.mediaSession.setActionHandler === 'function') {
                const actions = {
                    play: () => music_off(false),
                    pause: () => music_off(true),
                    nexttrack: () => next_track(),
                    previoustrack: () => {
                        if (state.tracks.length > 0) {
                            state.index = (state.index - 2 + state.tracks.length) % state.tracks.length
                            next_track()
                        }
                    },
                    seekto: details => {
                        if (details.seekTime !== undefined) audio.currentTime = details.seekTime
                    },
                }
                // iOS displays seekbackward/seekforward instead of prev/next if set.
                Object.entries(actions).forEach(([action, callback]) => {
                    try {
                        navigator.mediaSession.setActionHandler(action as MediaSessionAction, scope.guard(callback))
                        scope.own(() => navigator.mediaSession.setActionHandler(action as MediaSessionAction, null))
                    } catch {}
                })
            }
            return () => scope.dispose()
        } catch (error) { scope.dispose(); throw error }
    })
    return <></>
}

// convert all tracks to MUSE & upload
/**
 * Upload multiple JSON payloads as .json files to https://p057.co/api/v1/upload
 *
 * Requires Node.js 18+ (fetch, FormData, Blob available globally)
 *
 * Example input:
 * [
 *   {
 *     filename: "users.json",
 *     data: [{ id: 1, name: "Cyrus" }],
 *     description: "User export",
 *     expiresIn: 24
 *   },
 *   {
 *     filename: "config.json",
 *     data: { env: "prod" }
 *   }
 * ]
 */
async function uploadJsonFiles(apiKey, items) {
    if (!apiKey || typeof apiKey !== "string") {
        throw new Error("A valid API key is required.");
    }

    if (!Array.isArray(items) || items.length === 0) {
        throw new Error("items must be a non-empty array.");
    }

    const results = [];

    for (const [index, item] of items.entries()) {
        const {
            filename,
            data,
            description,
            expiresIn
        } = item ?? {};

        if (!filename || typeof filename !== "string") {
            throw new Error(`items[${index}].filename must be a non-empty string.`);
        }

        if (data === undefined) {
            throw new Error(`items[${index}].data is required.`);
        }

        const blob = new Blob([data], { type: "application/json" });

        const form = new FormData();
        form.append("file", blob, filename);

        if (description != null) {
            form.append("description", String(description));
        }

        if (expiresIn != null) {
            form.append("expiresIn", String(expiresIn));
        }

        const response = await fetch("https://p057.co/api/v1/upload", {
            method: "POST",
            headers: {
                "X-API-Key": apiKey
            },
            body: form
        });

        let body;
        const text = await response.text();

        try {
            body = JSON.parse(text);
        } catch {
            body = { raw: text };
        }

        if (!response.ok || !body.success) {
            throw new Error(
                `Upload failed for "${filename}": ${response.status} ${response.statusText} - ${JSON.stringify(body)}`
            );
        }

        results.push({
            filename,
            url: body.url,
            postId: body.postId,
            expiresAt: body.expiresAt ?? null
        });
    }

    return results;
}
// setTimeout(async () => {
//     const file_objects = Object.entries(tracks).filter(([_, track]) => track.list === track_lists.THEME).map(([id, track]) => {
//         // track shape
//         // [track_ids.BEAUTIFUL]: {
//         //     title: 'Beautiful',
//         //     artist: 'Rhye',
//         //     album: undefined,
//         //     list: track_lists.THEME,
//         //     audio: '/raw/audio/tracks/theme/beautiful.mp3',
//         //     image: '/raw/audio/tracks/theme/beautiful.jpg',
//         //     href: 'https://rhyemusic.bandcamp.com/album/beautiful',
//         //     flavor: 'so beautiful',
//         // },
//         return {
//             filename: `${id}.muse`,
//             data: JSON.stringify({
//                 spec: 'MUSE',
//                 version: 1,
//                 type: 'song',
//                 title: track.title,
//                 artist: track.artist,
//                 audio: 'https://freshman.dev' + track.audio,
//                 art: 'https://freshman.dev' + track.image,
//                 distributable: false,
//                 url: {
//                     audio: track.href,
//                 },
//             }, null, 2),
//             description: `${track.title} by ${track.artist} @muse /tracks`,
//         }
//     })
//     console.log({file_objects})

//     try {
//         const uploaded = await uploadJsonFiles('pk_375cc9535ba1b02496dd4c86a07399656785fd3096f4cfd1b1444183349bb612', file_objects);
//         console.log("Uploaded files:", uploaded);
//     } catch (err) {
//         console.error(err);
//     }
// }, 5_000)
